module.exports = __webpack_public_path__ + "media/assets/img/flags/qu-PE-8e297e08a313b04d129871a85718da61.png";